import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  useDisclosure,
  Text,
  Flex,
} from "@chakra-ui/react";
import { ExclamationCircleIcon } from "../../../styles/icons/ExclamationCircleIcon";
import { TrashIcon } from "../../../styles/icons/TrashIcon";

export function DeletBrandModal({ setOrganizedRates, tabStatus, brand, onEdit }) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const handleRemoveBrand = () => {
    setOrganizedRates((prevRates) => {
      const updatedRates = { ...prevRates };

      if (updatedRates[tabStatus]) {
        updatedRates[tabStatus] = updatedRates[tabStatus].filter(
          (item) => item?.paymentBrandModel?.brandCard?.toLowerCase() !== brand?.paymentBrandModel?.brandCard?.toLowerCase()
        );
      }

      return updatedRates;
    });

    onClose();
  };

  return (
    <>
      <Button
        backgroundColor="white"
        isDisabled={!onEdit}
        maxW="16px"
        maxH="16px"
        h="16px"
        w="16px"
        p="0"
        _hover={{ backgroundColor: "none" }}
        alignItems="center"
        onClick={onOpen}
        cursor="pointer">
        <TrashIcon />
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <Flex flexDirection="row" alignItems="flex-start" gap="16px" p="32px 24px 0 24px">
            <ExclamationCircleIcon />
            <Flex flexDirection="column" flex="1">
              <ModalHeader color="rgba(0, 0, 0, 0.85)" mb={2} p="0" fontSize="18px" lineHeight="22px">
                Excluir bandeira
              </ModalHeader>
              <ModalBody p="0" display="flex" flexDirection="column" gap="20px">
                <Text color="rgba(0, 0, 0, 0.85)" fontSize="14px" lineHeight="22px">
                  Tem certeza que deseja excluir a bandeira <Text as="span" fontWeight="700">
                    {brand?.paymentBrandModel?.brandCard}
                  </Text>?
                </Text>
                <Text color="rgba(0, 0, 0, 0.85)" fontSize="14px" lineHeight="22px">
                  Todas as transações realizadas nessa bandeira utilizarão as taxas padrão.
                </Text>
              </ModalBody>
            </Flex>
          </Flex>

          <ModalFooter gap="12px" p="24px">
            <Button variant="outline" onClick={onClose} h="32px">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleRemoveBrand} h="32px">
              Excluir
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
